import { Columns03 } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCmp from 'src/components/ButtonCmp';

interface IProps {
    isEditing: boolean;
    hasChanges: boolean;
    onOpen: () => void;
    onCancel: () => void;
    onSave: () => void;
    isDisabled?: boolean;
}

/** Column-manager trigger: the columns icon, swapped for Cancel / Save while the manager is open. */
const DraggableColumnsButton = ({ isEditing, hasChanges, onOpen, onCancel, onSave, isDisabled = false }: IProps) => {
    const { t } = useTranslation();

    if (!isEditing) {
        return (
            <ButtonCmp className="btn_secondary_black flex-none" onClick={onOpen} size="square-sm" disabled={isDisabled} icon={<Columns03 className="w-4 h-4" />}>
                <></>
            </ButtonCmp>
        );
    }

    return (
        <>
            <ButtonCmp type="button" onClick={onCancel} className="btn_secondary_black">
                {t('Common.Cancel')}
            </ButtonCmp>
            <ButtonCmp type="button" onClick={onSave} disabled={!hasChanges} className="btn-outline-primary">
                {t('Common.Save')}
            </ButtonCmp>
        </>
    );
};

export default DraggableColumnsButton;
